import { Fragment, useEffect, useState } from 'react'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useFetcher, useNavigate } from '@remix-run/react'
import { Doc } from '#convex/_generated/dataModel.js'


function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

type ReclassifyButtonProps = {
  regions: Doc<"Region">[]
  region: string
}

export default function RegionToggleButton({regions, region}: ReclassifyButtonProps) {
  const [selected, setSelected] = useState<Doc<"Region"> | null>(region ? regions.find(r => r._id === region) ?? null : null)
  const fetcher = useFetcher();

  useEffect(() => {
    if (!region && regions.length > 0) {
      setSelected(regions[0])
      handleRegionChange(regions[0])
    }
  }, [regions]);

  const handleRegionChange = (newRegion: any) => {
    let formData = new FormData();
    formData.set('region', newRegion._id)
    fetcher.submit(
      formData,
      { method: 'post', action: '/resources/agency-region-cookie' }
    );
    setSelected(newRegion)
  };


  if(selected == null) {
    return <div className="h-11"/>;
  }

  if(regions.length === 1) {
    return <div className="h-11">
      <p className="inline-flex justify-center gap-x-1.5 p-3 text-xs uppercase text-white">{selected.name}</p>
    </div>;
  }

  return (
    <Menu as="div" className="relative inline-block text-left mb-1 ml-1">
      <div>
        <MenuButton className="inline-flex justify-center gap-x-1.5 p-3 text-xs uppercase text-white hover:bg-darkBlue rounded ">
          {selected ? regions.find(region => region._id === selected._id)?.name : 'Select Region'}
          <ChevronDownIcon className="-mr-1 h-3 w-3 text-white" aria-hidden="true" />
        </MenuButton>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute left-0 z-10 mt-2 w-56 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none top-full">
          <div className="py-1">
            {regions.map(function(region, index) {
              return <MenuItem key={index}>
              {({ active }) => (
                <a
                  className={classNames(
                    active ? 'bg-blue text-white' : 'text-blue',
                    'block px-4 py-2 text-sm hover:bg-darkBlue hover:text-white'
                  )}
                  onClick={() => {
                    handleRegionChange(region)
                  }}
                >
                  {region.name}
                </a>
              )}
            </MenuItem>
            })}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  )
}
